import React from 'react';

require('style/Checkbox');

export default class Checkbox extends React.Component {
  render() {
    return (
      <label className={"Checkbox" + (this.props.disabled ? ' disabled' : '') + this.props.className}>
        <input type="checkbox" checked={this.props.checked} onChange={(evt) => this.props.onChange(evt.target.checked ? 1 : 0)} disabled={this.props.disabled} />
        {this.props.label || "Enabled"}
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/Checkbox.js